<template>
    <div class="tl-row">
        <div class="tl-columnheader">
            <h2 class="tl-tit">시공 예산 <span class="color-red">*</span></h2>
        </div>
        <div class="tl-cell">
            <div class="form-inline">
                <select class="select" required @change="setBudget">
                    <option hidden>금액을 선택해주세요.</option>
                    <option v-for="n in 9" :key="n" :value="(n * 1000).format() + '만원 이하'">{{ (n * 1000).format() }}만원 이하</option>
                    <option value="1억원 이하">1억원 이하</option>
                    <option value="1억원 이상">1억원 이상</option>
                    <option value="상담 후 결정">미정 (상담 후 결정)</option>
                    <option value="직접 입력">직접 입력</option>
                </select>
                <div class="form-text">
                    <input :type="showInput ? 'number' : 'hidden'" v-model="budget" placeholder="예산을 입력해주세요." @input="setInput" />
                    <span v-if="showInput" class="ft-txt">만원</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            budget: "",
            showInput: false,
        };
    },
    methods: {
        setBudget(event) {
            if (event.target.value == "직접 입력") {
                this.budget = "";
                if (!this.showInput) this.showInput = true;
                this.setInput();
            } else {
                this.budget = event.target.value;
                if (this.showInput) this.showInput = false;
                this.setInput();
            }
        },
        setInput() {
            const budget = this.budget;
            this.$emit("set-input", { budget });
        },
    },
};
</script>
